<template>
  <!--eslint-disable-->
  <v-row class="ma-0">
    <v-alert
      dense
      outlined
      type="error"
      width="100%"
      class="mr-2"
      v-if="confirmErrorMessage"
    >
      {{ confirmErrorMessage }}
    </v-alert>

    <v-col cols="12" class="pa-0 pt-3 ma-0">
      <v-text-field
        disabled
        class="pa-0 ma-0"
        v-model="confirmData.username"
        :label="userNameType"
      />
    </v-col>

    <v-col cols="12" class="pa-0 pt-3 ma-0">
      <v-text-field
        class="pa-0 ma-0"
        v-model="confirmData.password.value"
        type="password"
        label="Пароль"
        :type="confirmData.password.type"
        required
        :append-icon="confirmData.password.icon"
        @click:append="confirmData.password.changeVisible()"
        :error-messages="passwordErrors"
        @input="$v.confirmData.password.value.$touch()"
        @blur="$v.confirmData.password.value.$touch()"
      />
    </v-col>

    <v-col cols="12" class="pa-0 pt-3 ma-0">
      <v-text-field
        class="pa-0 ma-0"
        v-model="confirmData.passwordConfirm.value"
        type="password"
        label="Подтверждение пароля"
        :type="confirmData.passwordConfirm.type"
        :append-icon="confirmData.passwordConfirm.icon"
        @click:append="confirmData.passwordConfirm.changeVisible()"
        :error-messages="passwordConfirmErrors"
        @input="$v.confirmData.passwordConfirm.value.$touch()"
        @blur="$v.confirmData.passwordConfirm.value.$touch()"
      />
    </v-col>

    <v-col cols="6" class="pa-0 mt-4">
      <v-btn
        depressed
        color="primary"
        class="mr-2"
        :loading="loading"
        :disabled="$v.$invalid || loading"
        @click="confirm"
      >
        {{ confirmText }}
      </v-btn>
    </v-col>
    <v-col
      :cols="isMobile ? 12 : 6"
      class="pa-0 mt-4"
      :class="isMobile ? 'text-left' : 'text-right'"
    >
      <v-btn outlined color="primary" class="px-2" to="/spm/login">
        <span class="d-none d-sm-flex">Страница входа</span>
        <span class="d-flex d-sm-none">Назад</span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { Registration } from '@/models'
import { authApi } from '@/api'
import { sameAs } from 'vuelidate/lib/validators'
import { formatLogin } from '@/scripts/formatLogin'

export default {
  name: 'PasswordCreate',
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
    userNameType: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    type: {
      type: String, // может быть 'forget' или 'registration'
      required: true,
    },
  },

  created() {
    this.confirmData.username = this.username
    this.confirmData.code = this.code
  },

  data() {
    return {
      confirmErrorMessage: null,
      confirmData: new Registration(),
      loading: false,
    }
  },

  computed: {
    passwordErrors() {
      const errors = []
      if (!this.$v.confirmData.password.value.$dirty) return errors
      !this.$v.confirmData.password.value.required
      && errors.push('Пароль не может быть пустым')
      return errors
    },
    passwordConfirmErrors() {
      const errors = []
      if (!this.$v.confirmData.passwordConfirm.value.$dirty) return errors
      !this.$v.confirmData.passwordConfirm.value.sameAsPassword
      && errors.push('Пароли не совпадают')
      return errors
    },
    confirmText() {
      if (this.type === 'registration') return 'Зарегистрироваться'
      if (this.type === 'forget') return 'Сохранить пароль'
    },
  },

  validations: {
    confirmData: {
      password: { value: { required: true } },

      passwordConfirm: {
        value: {
          sameAsPassword: sameAs(function checkSameAsPassword() {
            return this.confirmData.password.value
          }),
        },
      },
    },
  },

  methods: {
    async confirm() {
      const body = {
        ...this.confirmData,
        username: formatLogin(this.confirmData.username),
        password: this.confirmData.password.value,
        passwordConfirm: this.confirmData.passwordConfirm.value,
      }

      this.loading = true
      try {
        this.confirmErrorMessage = null
        if (this.type === 'registration') await this.confirmRegistration(body)
        else if (this.type === 'forget') await this.confirmReset(body)

        await this.login()
      } catch (e) {
        if (e.status === 406 || e.status === 409) {
          this.confirmErrorMessage = e.data?.message
        } else {
          this.showErrorMessage(e, 'Возникла ошибка. Проверьте, введен ли пароль')
        }
      } finally {
        this.loading = false
      }
    },

    async login() {
      const loginBody = {
        username: formatLogin(this.confirmData.username),
        password: this.confirmData.password.value,
      }

      try {
        const data = await this.$store.dispatch('user/login', loginBody)
        if (data.username) {
          await this.$router.push('/')
        }
      } catch (e) {
        this.showErrorMessage(e, 'Не удалось войти. Попробуйте еще раз')
        await this.$router.push('/spm/login')
      }
    },

    async confirmRegistration(body) {
      await authApi.confirmRegistration(body)
    },

    async confirmReset(body) {
      await authApi.confirmReset(body)
    },
  },
}
</script>
